/* SongValley 1.1: broad media-icon replacement disabled.
   Native component icons remain in control to prevent duplicate play/pause overlays. */
(function () {
  'use strict';
  window.SVProfessionalMediaIconsDisabled = true;
})();
